
export default {
    name: 'AnnotationZoneImplantation',
    data() {
        return {
            isZoneImplantation: false
        }
    },
    props: {
         element: {
            type: Object,
            required: true
        },
    },
    mounted() {
        this.isZoneImplantation = this.element.zone_implantation

    },
    methods: {
        updateElement() {
            let zone_implantation = this.isZoneImplantation 
            let strokeWeight = this.isZoneImplantation ? 3 : 3;
            let strokeColor = this.isZoneImplantation ? '#22ce73' : '#3861FB';
            let fillColor = this.isZoneImplantation ? '#22ce73' : '#3861FB';

            this.$store.dispatch('updateAnnotationsElement', {
                id: this.element.id,
                fillColor: fillColor,
                strokeColor: strokeColor,
                strokeWeight: strokeWeight,
                zone_implantation: zone_implantation
            })
        },
        updateStrokeWeight(weight) {
            
        },
        updateFillOpacity(opacity) {
            
        }
    },
    components: {
    }
}
